import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc5afa7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabcont clearfix" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "cont" }
const _hoisted_10 = {
  key: 0,
  class: "line"
}

import {reactive, onMounted , watch ,ref} from "vue";
 import { getEnum  } from "@/api/index";
 
import { useRouter , useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  isMobile: Boolean,
  checked: String,
},
  emits: ['onChecked'],
  setup(__props, { emit }) {

const props = __props


 
const mb =ref(false);
 watch(
  () => props.isMobile,
  (newv, oldv) => {
       props.isMobile? mb.value = true : mb.value = false;    
  }
);
 
const router = useRouter();
const route = useRoute();
 
const datas: any = reactive({
  tabs:'',
  filurl:localStorage.getItem('fileUrel'),
});

 
const getTabs = () => {
  datas.tabs ={};
  getEnum("PRODUCT").then((res: any) => {
    for (const item of res.data) {
      item.extData =  (item.extData.split(',')).filter(function (s: any) {
            return s && s.trim(); 
      });
       datas.tabs[item.enumKey] = item;
       datas.tabs[item.enumKey].checked = false;
       datas.tabs[item.enumKey].remark = datas.tabs[item.enumKey].remark.split(',');
    }
    if(props.checked) {
      datas.tabs[props.checked].checked = true;
    } else {
        datas.tabs['PRODUCT_EDUCATION'].checked = true;
    }
  });
};
 


const check = (k: any) =>{
  for(const item in  datas.tabs) {
     datas.tabs[item].checked = false;
  }
  datas.tabs[k].checked = true;
   emit('onChecked', k);
};




onMounted(() => {
  getTabs();
  mb.value =props.isMobile;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.tabs, (v, k) => {
          return (_openBlock(), _createElementBlock("li", {
            key: k,
            onClick: ($event: any) => (check(k)),
            class: _normalizeClass({checked:v.checked})
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: v.checked?datas.filurl+v.extData[1]:datas.filurl+v.extData[0],
                alt: ""
              }, null, 8, _hoisted_5),
              _hoisted_6,
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", null, _toDisplayString(v.enumName), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.remark, (item, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(mb.value?'':item), 1))
                }), 128))
              ]),
              (k!='PRODUCT_CONFER')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_3))
        }), 128))
      ])
    ])
  ]))
}
}

})